<template>
  <div id="page" :class="{'is-ios': isIOS}">
    <div class="app-content" :class="{show: show}">
      <v-scroller
          class="app-container"
          :class="{'header-type2': headerType === 1}"
          :preload-top="50"
          :preload-bottom="50"
          :throttle="0"
          :event-step="1"
          @scroll="handleScroll"
      >
        <div class="app-background" :class="{'is-upgrade': isUserUpgrade}" :style="appUserConf.native_header_image ? {backgroundImage: 'url(' + ossUrl + appUserConf.native_header_image + ')'} : {}"></div>
        <div class="app-btns">
          <template v-if="moduleBtns.length">
            <span class="icon" v-for="(btn, k) in moduleBtns" :key="k"><img :src="btn.image_full" alt=""></span>
          </template>
          <template v-else>
            <span class="icon"><i class="iconfont icon-xiaoxi" :style="{color: appUserConf.header_text_color}"></i></span>
            <span class="icon"><i class="iconfont icon-shezhi" :style="{color: appUserConf.header_text_color}"></i></span>
          </template>
        </div>
        <div class="user-info" ref="userInfoWrap">
          <div class="sticky-bg" ref="userInfoBg"></div>
          <div class="avatar" ref="avatar" @click="onShowMob"><img :src="userInfo.avatar" alt=""></div>
          <div class="flex" ref="userInfo" :style="{color: appUserConf.header_text_color}">
            <div class="row row1">
              <span class="name">{{userInfo.nickname}}</span>
              <span class="level" ref="level" v-if="+appUserConf.native_is_level"><img v-if="level_icon" :src="level_icon" alt=""></span>
            </div>
            <div class="row row2" ref="invite" v-if="+appUserConf.native_is_invite">
              <span class="invite-code">邀请码：{{userInfo.custom_invite_code || userInfo.invite_code}}</span>
              <span class="copy">复制</span>
            </div>
          </div>
        </div>
        <div class="user-upgrade" v-if="isUserUpgrade && headerType === 0">
          <div class="img">
            <img v-if="appUserConf.header_guide_upgrade_img" :src="this.ossUrl + appUserConf.header_guide_upgrade_img" alt="" style="width: 5.76rem">
            <img v-else src="@/assets/images/upgrade.png" alt="" style="width: 5.76rem">
          </div>
          <div v-if="false" class="container">
            <span class="icon"><i class="iconfont icon-shengji"></i></span>
            <span class="text">前往升级获取更高特权</span>
            <div class="btn-wrap"><span class="btn">立即升级</span></div>
          </div>
        </div>
        <div class="user-property" v-if="headerType === 0" :style="{color: appUserConf.withdraw_text_color, backgroundImage: appUserConf.native_top_withdraw_img ? 'url(' + ossUrl + appUserConf.native_top_withdraw_img + ')' : ''}">
          <div class="total-balance" style="height: 0.78rem">
            <div class="column">
              <div class="t1">
                <span class="t">{{this.appUserConf.native_header_withdraw_title || '账户可用余额'}}</span>
                <span class="mark">￥</span>
                <span class="num" v-if="false">0.00</span>
                <input type="number" class="num input-number" :style="{color: appUserConf.withdraw_text_color}" v-model="num1">
              </div>
              <div class="t2">{{appUserConf.native_header_withdraw_desc}}</div>
            </div>
            <div class="column">
              <span class="btn" :style="{borderColor: appUserConf.withdraw_text_color}">提现</span>
            </div>
          </div>
          <div class="item-balance">
            <div class="item" v-for="(item, k) in customCenter" :key="k" v-if="item.name">
              <span class="num" v-if="false">0.00</span>
              <input type="number" class="num input-number" :style="{color: appUserConf.withdraw_text_color}" ref="inputNum" value="0.00" @blur="(e) => onChangeNum(k, e)">
              <span class="label">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="user-property user-property2" v-if="headerType === 1" :style="{color: appUserConf.withdraw_text_color}">
          <div class="item-balance" :style="{color: appUserConf.header_text_color}">
            <div class="item" v-for="(item, k) in customCenter" :key="k" v-if="item.name">
              <span class="num" v-if="false">0.00</span>
              <input type="number" class="num input-number" :style="{color: appUserConf.header_text_color}" ref="inputNum" value="0.00" @blur="(e) => onChangeNum(k, e)">
              <span class="label">{{item.name}}</span>
            </div>
          </div>
          <div class="total-balance" :style="{backgroundImage: appUserConf.native_top_withdraw_img ? 'url(' + ossUrl + appUserConf.native_top_withdraw_img + ')' : ''}">
            <div class="column">
              <div class="t1">
                <span class="t">{{this.appUserConf.native_header_withdraw_title || '账户可用余额'}}</span>
                <span class="mark">￥</span>
                <span class="num" v-if="false">0.00</span>
                <input type="number" class="num input-number" :style="{color: appUserConf.withdraw_text_color}" v-model="num1">
              </div>
              <div class="t2">{{appUserConf.native_header_withdraw_desc}}</div>
            </div>
            <div class="column">
              <span class="btn" :style="{borderColor: appUserConf.withdraw_text_color}">提现</span>
            </div>
          </div>
          <template v-if="isUserUpgrade">
            <div class="user-upgrade" v-if="appUserConf.header_guide_upgrade_img">
              <div class="img">
                <img :src="this.ossUrl + appUserConf.header_guide_upgrade_img" alt="">
              </div>
            </div>
            <div class="upgrade-sticky" v-else>
              <span class="icon"><i class="iconfont icon-set-automatic-upgrade"></i></span>
              <span class="text">立即升级</span>
            </div>
          </template>
        </div>
        <template v-for="(module) in moduleConf">
          <div class="module-image" :class="{margin: +module.margin, 'side-margin': +module.side_margin}" v-if="module.type === 'user' && +module.module_id === 1 && module._rows.length">
            <div class="item" @click="onClickModule(item)" v-for="(item, kk) in module.rows" :key="kk" v-if="item.show">
              <span class="icon"><img :src="item.image_full || (ossUrl + item.image)" alt=""></span>
            </div>
          </div>
          <div class="module-banner" :class="{margin: +module.margin, 'side-margin': +module.side_margin}" v-if="module.type === 'user' && +module.module_id === 2 && module._rows.length">
            <div class="swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" @click="onClickModule(item)" v-for="(item, kk) in module.rows" :key="kk" v-if="item.show"><img :src="item.image_full || (ossUrl + item.image)" alt=""></div>
              </div>
            </div>
          </div>
          <div class="module-layer" :class="{margin: +module.margin, 'side-margin': +module.side_margin}" v-if="module.type === 'user' && +module.module_id === 3 && module._rows.length">
            <div class="layer-title" v-if="+module.conf.native_is_title">{{module.conf.native_title}}</div>
            <div class="list">
              <div class="item" v-for="(item, kk) in module.rows" :key="kk" v-if="item.show" @click="onClickModule(item)">
                <span class="icon"><img :src="item.image_full" alt=""></span>
                <span class="name">{{item.name}}</span>
              </div>
            </div>
          </div>
        </template>
      </v-scroller>
    </div>
    <div class="app-tabBar" :class="{show: show}">
      <div class="item" v-for="(item, k) in tabBar" :key="k" @click="onClickModule(item)">
        <template v-if="item.page_name === '会员中心'">
          <span class="icon" v-if="item.image_cur.indexOf('http') === 0"><img :src="item.image_cur" alt=""></span>
          <span class="icon" v-else><img :src="ossUrl + item.image_cur" alt=""></span>
          <span class="name" :style="{color: item.footer_focus_color}">{{item.name}}</span>
        </template>
        <template v-else>
          <span class="icon" v-if="item.image.indexOf('http') === 0"><img :src="item.image" alt=""></span>
          <span class="icon" v-else><img :src="ossUrl + item.image" alt=""></span>
          <span class="name">{{item.name}}</span>
        </template>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showDialogMob" class="confirm-dialog">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">推送设置</strong></div>
          <div class="weui-dialog__bd">
            <div class="form">
              <div class="wrap">
                <div class="weui-cells">
                  <div class="weui-cell">
                    <div class="weui-cell__bd">新订单通知</div>
                    <div class="weui-cell__ft">
                      <input v-model="orderTeam" type="number" :placeholder="'请输入推送条数'">
                    </div>
                  </div>
                  <div class="weui-cell">
                    <div class="weui-cell__bd">订单结算通知</div>
                    <div class="weui-cell__ft">
                      <input v-model="teamOrderSuccess" type="number" :placeholder="'请输入推送条数'">
                    </div>
                  </div>
                  <div class="weui-cell">
                    <div class="weui-cell__bd">团队注册通知</div>
                    <div class="weui-cell__ft">
                      <input v-model="inviteTeamSuccess" type="number" :placeholder="'请输入推送条数'">
                    </div>
                  </div>
                </div>
              </div>
              <div class="tips">
                <div class="text">单个通知类型最大推送条数：300条</div>
                <div class="text">以300条为例，即单个通知类型为：1秒1条</div>
                <div class="text">首次测试建议设置：20-50条</div>
              </div>
            </div>
          </div>
          <div class="weui-dialog__ft">
            <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="onCancelMob">取消</a>
            <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="onPushMob">提交推送</a>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast weui-toast_text">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
          <p class="weui-toast__content">加载中...</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
#page {
  position: relative;
  height: 100vh;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

img {
  vertical-align: top;
  touch-action: none;
  user-select: none;
  pointer-events:none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}

.is-ios .app-tabBar {
  padding-bottom: 0.62rem;
  &:before {
    background-color: #c4c4c4;
    opacity: 1;
  }
}
.app-tabBar {
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  opacity: 0;
  height: 0.9rem;
  &:before {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 0.5px;
    background-color: #c4c4c4;
    opacity: 0.2;
    content: '';
    z-index: 102;
  }
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    color: #555;
    font-size: 11px;
    .icon {
      padding-top: 0.12rem;
      height: 0.38rem;
      padding-bottom: 0.05rem;
      img {
        max-height: 100%;
      }
    }
  }
}

.app-tabBar.show {
  opacity: 1;
}

.app-content {
  flex: 1;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.2s ease;
  background-color: #f6f6f6;
  color: #000;
  .app-container {
    position: relative;
    padding-bottom: 0.18rem;
    box-sizing: border-box;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
    &.header-type2 .app-background {
      height: 4.6rem !important;
      border-radius: 0;
    }
  }
  .app-background {
    background-size: cover;
    background-position: center 0;
    background-repeat: no-repeat;
    position: absolute;
    left: -0.4rem;
    right: -0.4rem;
    top: 0;
    height: 3.5rem;
    border-radius: 0 0 10% 10%;
    &.is-upgrade {
      height: 4.5rem;
    }
  }
}

.app-content.show {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s;
}

.swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  object-fit: cover;
}

.app-btns {
  position: sticky;
  left: 0;
  right: 0.32rem;
  top: 0.88rem;
  padding-right: 0.33rem;
  z-index: 102;
  text-align: right;
  .icon {
    padding-left: 0.24rem;
    .iconfont {
      font-size: 0.42rem;
    }
    img {
      max-height: 0.38rem;
    }
  }
}

.user-upgrade {
  position: relative;
  z-index: 10;
  .img {
    text-align: center;
  }
  img {
    max-width: 100%;
  }
  .container {
    margin: 0 0.86rem;
    height: 0.74rem;
    background-color: #000;
    border-radius: 0.2rem 0.2rem 0 0;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 0.18rem;
    .icon {
      padding-left: 0.1rem;
      padding-right: 0.16rem;
      .iconfont {
        color: #b9ab8c;
      }
    }
    .text {
      transform: scale(0.9) translateX(-6%);
      color: rgba(255, 255, 255, 0.9);
    }
    .btn-wrap {
      flex: 1;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn {
        height: 0.4rem;
        line-height: 0.44rem;
        padding: 0 0.1rem;
        color: rgb(215, 202, 153);
        border: 1px rgb(215, 202, 153) solid;
        border-radius: 4px;
        overflow: hidden;
        transform: scale(0.9) translateX(5%);
      }
    }

  }
}

.upgrade-sticky {
  position: absolute;
  right: -0.3rem;
  top: -0.56rem;
  height: 0.46rem;
  width: 1.65rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #2d2d2d;
  color: #fff;
  border-radius: 0.48rem 0 0  0.48rem;
  .icon {
    position: relative;
    &:after {
      position: absolute;
      width: 7px;
      height: 8px;
      background-color: #fff;
      content: '';
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-80%);
    }
  }
  .icon .iconfont {
    position: relative;
    z-index: 9;
    font-size: 14px;
    color: #f8c75e;
  }
  .text {
    padding-left: 0.1rem;
    font-size: 11px;
  }
}

.user-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.9rem 0.28rem 0.26rem 0.28rem;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 101;
  .sticky-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1.86rem;
    background-size: cover;
    background-position: center 0;
    background-repeat: no-repeat;
  }
  .avatar {
    position: relative;
    width: 0.92rem;
    height: 0.92rem;
    border-radius: 50%;
    margin-right: 0.28rem;
    z-index: 99;
    overflow: hidden;
    img {
      border-radius: 50%;
      overflow: hidden;
    }
  }
  .flex {
    display: flex;
    flex-direction: column;
    color: #000;
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      font-size: 0.34rem;
      font-weight: bold;
    }
    .copy {
      margin-left: 0.18rem;
      text-decoration: underline;
    }
    .level {
      padding-left: 0.2rem;
      height: 0.3rem;
      img {
        max-height: 100%;
      }
    }
  }
}

.form {
  position: relative;
  top: -15px;
  overflow: hidden;
  .weui-cells {
    margin: 0;
    &:after, &:before {
      display: none;
    }
    .weui-cell {
      padding: 12px 0;
      &:before {
        left: 0;
      }
      .weui-cell__bd {
        font-size: 15px;
      }
      input, span {
        text-align: right;
        border: 0;
        color: #000;
        background-color: #fff;
        font-size: 15px;
        outline:none;
      }
      input:disabled,
      input[disabled] {
        -webkit-text-fill-color: rgba(0,0,0,0.3) !important;
        opacity: 1;
      }
    }
  }
  .tips {
    padding-top: 0.24rem;
    .text {
      font-size: 14px;
      color: #fa8c16;
      padding-bottom: 3px;
    }
  }
}

.confirm-dialog {
  position: relative;
  z-index: 103;
  .weui-dialog__btn_primary {
    color: #588aff;
  }
  .weui-dialog__title {
    font-size: 18px;
  }
  .weui-dialog__hd {
    padding-top: 20px;
    padding-bottom: 24px;
  }
  .weui-dialog__bd {
    text-align: left;
    margin-bottom: 0;
    p {
      width: 270px;
      margin: 0 auto;
      padding-bottom: 2px;
      span {
        color: #f75f6e;
      }
    }
  }
}

.user-property {
  position: relative;
  background-color: #fff;
  margin: 0 0.28rem 0.28rem;
  padding: 0 0.3rem;
  border-radius: 0.18rem;
  z-index: 99;
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  .input-number {
    border: 0;
    width: 100%;
    outline: none;
    box-sizing: border-box;
    background-color: transparent;
    &:focus {
      border: 1px #c4c4c4 solid;
      border-radius: 4px;
      text-align: center;
    }
  }
  .total-balance {
    padding: 0.2rem 0;
    border-bottom: 1px rgba(0, 0, 0, 0.035) solid;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-size: cover;
    background-position: center bottom;
    background-repeat: no-repeat;
    .column {
      display: flex;
      flex-direction: column;
      .t1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 1.2;
        .t {
          font-size: 0.28rem;
          padding-top: 0.05rem;
        }
        .mark {
          font-size: 0.28rem;
          margin-left: 0.1em;
          padding-top: 0.05rem;
        }
        .num {
          font-size: 0.36rem;
          font-weight: 500;
          font-family: 'UDC';
          width: 2.5rem;
        }
      }
      .t2 {
        font-size: 12px;
        transform: scale(0.85) translateX(-9%);
      }
      .btn {
        padding: 0.1rem 0.26rem;
        line-height: 1;
        border: 1px #000 solid;
        border-radius: 0.4rem;
        font-weight: 500;
      }
    }
  }
  .item-balance {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 0.14rem 0 0.24rem 0;
    margin-bottom: 0.1rem;
    .item {
      line-height: 1.1;
      text-align: center;
      display: flex;
      flex-direction: column;
      .num {
        font-size: 0.36rem;
        font-weight: 500;
        font-family: 'UDC';
        margin-bottom: 0.08rem;
        text-align: center;
      }
      .label {
        font-size: 0.26rem;
      }
    }
  }
}

.user-property.user-property2 {
  background-color: transparent;
  padding-left: 0;
  padding-right: 0;
  .item-balance {
    padding-top: 0;
  }
  .total-balance {
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    background-color: #fff;
    border-radius: 0.18rem;
    border-bottom: 0;
  }
}

.module-image {
  position: relative;
  z-index: 9;
  overflow: hidden;
  &.margin {
    margin-top: 0.18rem;
  }
  &.side-margin {
    margin-left: 0.28rem;
    margin-right: 0.28rem;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  .item {
    flex: 1;
    img {
      max-width: 100%;
    }
  }
}

.module-banner {
  position: relative;
  z-index: 9;
  overflow: hidden;
  &.margin {
    margin-top: 0.18rem;
  }
  &.side-margin {
    margin-left: 0.28rem;
    margin-right: 0.28rem;
    .swiper-slide {
    }
  }
}

.module-layer,
.module-image,
.module-banner {
}

.module-layer {
  position: relative;
  background: rgba(255,255,255, 0.85);
  z-index: 9;
  color: #555;
  &:first-child {
    color: #333;
  }
  &.margin {
    margin-top: 0.18rem;
  }
  &.side-margin {
    margin-left: 0.28rem;
    margin-right: 0.28rem;
    border-radius: 0.18rem;
  }
  .layer-title {
    height: 0.76rem;
    line-height: 0.8rem;
    border-bottom: 1px #f8f8f8 solid;
    font-size: 0.3rem;
    font-weight: 500;
    padding-left: 0.32rem;
    overflow: hidden;
  }
  .list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.24rem 0 0.12rem 0;
  }
  .item {
    width: 25%;
    padding-bottom: 0.12rem;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    .icon {
      height: 0.72rem;
    }
    .name {
      padding-top: 0.12rem;
      font-size: 12px;
    }
  }
}

</style>

<script>
import request from "@/pages/course/utils/request";
import gfRequest from "@/pages/course/utils/gfRequest";
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: true,
      checkAppKey: false,
      checkUserInfo: false,
      isExpiryAtOut: false,
      showToast: false,
      showDialogMob: false,
      toastMsg: '',
      memberId: null,
      userInfo: {},
      level_icon: '',
      appEnv: {
        prod: process.env.VUE_APP_RELEASE === 'prod',
        appId: '',
        appKey: '',
      },
      ossUrl: '',
      moduleConf: [],
      moduleBtns: [],
      agentConf: {},
      teamConf: {},
      appCoreConf: {},
      appUserConf: {},
      customCenter: [],
      agentLevel: [],
      teamLevel: [],
      headerType: 0,
      isUserUpgrade: false,
      tabBar: [],
      num1: '0.00',
      num2: '0.00',
      num3: '0.00',
      num4: '0.00',
      num5: '0.00',
      openAppKey: '',
      inviteTeamSuccess: null,
      orderTeam: null,
      teamOrderSuccess: null,
    };
  },
  computed: {
    isIOS() {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
  },
  created() {
    this.appEnv.prod = process.env.VUE_APP_RELEASE === 'prod';
    if (!this.appEnv.prod) {
      const appEnv = {
        prod: this.appEnv.prod,
        appId: 'CC202104110012172897',
        appKey: 'EDF0763043A073BC',
        platformId: 22,
      }
      // const userInfo = {
      //   id: 122551,
      //   invite_code: "120897",
      //   custom_invite_code: '文贤啊',
      //   avatar: "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLD9jWrnw4j9YFHIKiaE71Pka0Bnz2t8vjcQGax1YibKPLehSjhfqd0uibFziaC1unYb5O80OUI7VDGsQ/132",
      //   nickname: "文贤",
      //   mobile: '18958906820',
      //   latitude: "27.921809",
      //   longitude: "120.811979",
      //   wechat_unionid: '',
      //   wx_openid: 'ozbMf5yw9AnKfs00RWxA9LzlSBHU',
      //   level_id: 1712,
      //   agent_level: 1,
      //   agent_name: '中级VIP',
      //   team_level_id: 0,
      // };
      // const appEnv = {
      //   prod: this.appEnv.prod,
      //   appId: 'CC202104141717292037',
      //   appKey: '0B2039D129EC52BB',
      //   platformId: 450,
      // }
      const userInfo = {
        id: 113505,
        invite_code: "57392186",
        custom_invite_code: '嗷嗷牛哇',
        avatar: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q3auHgzwzM7tKXMB8ntK2vEMpLsIDAAS0kKYmeiaVHAMuxic7R46lzibTktQQqKLQ7I13NCzclNg1thiaYKd3ueBKw/132",
        nickname: "神经蛙",
        mobile: '15258092978',
        wechat_unionid: 'oa1kh08kqt_f2horau08djjtDHOI',
        wx_openid: 'oAghLt3MnJr_JUg2D6flh1GU95to',
        level_id: 2122,
        agent_level: 2,
        agent_name: '合伙人',
        team_level_id: 0,
      };
      this.appEnv = appEnv;
      this.userInfo = userInfo;
      new VConsole();
    }
  },
  mounted() {
    const prod = this.appEnv.prod;
    const appEnv = prod ? Object.assign({}, this.appEnv, {appKey: ''}) : this.appEnv;
    const appId = this.$route.query.appid ||'';
    const platformId = this.$route.query.platformid || '';
    if (appId) appEnv.appId = appId;
    if (platformId) appEnv.platformId = parseInt(platformId, 10) || 0;
    if (!appEnv.appId || !appEnv.platformId) {
      this.showLoading = false;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    this.appEnv = appEnv;
    setNavigationBar({
      native_headershow: 0,
      statusBarAppearance: 1
    })

    const h5Userinfo = getH5UserInfo();
    if (h5Userinfo) {
      new Promise(async () => {
        await h5Userinfo.then((resp) => {
          this.checkUserInfo = true;
          this.userInfo = JSON.parse(resp);
          console.log(this.userInfo)
        }).catch((err) => {
          this.showLoading = false;
          if (typeof err === 'object') {
            this.toast('未能获取到用户信息请联系客服: ' + JSON.parse(err));
          } else if (typeof err === 'string') {
            this.toast('未能获取到用户信息请联系客服: ' + err);
          }
        });
        let appKey = '';
        await checkAppInfo().then(version => {
          appKey = version;
        }).catch((err) => {});
        await this.getTenantCfg(appKey).catch((err) => {});
        await this.appMemberLink().catch(err => {});
        if (this.checkAppKey && !this.isExpiryAtOut) {
          await this.getMagicConf().catch((err) => {});
          await this.getMemberMagic().catch((err) => {});
          this.show = true;
          this.showLoading = false;
          this.$refs.inputNum.forEach((item, k) => {
            if (k === 0) {
              item.value = this.num2
            } else if (k === 1) {
              item.value = this.num3
            } else if (k === 2) {
              item.value = this.num4
            } else if (k === 3) {
              item.value = this.num5
            }
          });
          this.$nextTick(() => {
            new Swiper(".swiper", {
              spaceBetween: 15,
              centeredSlides: true,
              autoplay: 3000,
            });
          })
        }
        this.showLoading = false;
        this.show = true;
      })
    } else {
      if (!this.appEnv.prod) {
        new Promise(async () => {
          await this.getTenantCfg(this.appEnv.appKey).catch((err) => {});
          await this.appMemberLink().catch(err => {});
          if (this.checkAppKey && !this.isExpiryAtOut) {
            await this.getMagicConf().catch((err) => {});
            await this.getMemberMagic().catch((err) => {});
            this.show = true;
            this.showLoading = false;
            this.$refs.inputNum.forEach((item, k) => {
              if (k === 0) {
                item.value = this.num2
              } else if (k === 1) {
                item.value = this.num3
              } else if (k === 2) {
                item.value = this.num4
              } else if (k === 3) {
                item.value = this.num5
              }
            });
            this.$nextTick(() => {
              new Swiper(".swiper", {
                spaceBetween: 15,
                centeredSlides: true,
                autoplay: 3000,
              });
            })
          }
          this.showLoading = false;
        })
      } else {
        this.showLoading = false;
        this.toast('未能获取到用户信息请联系客服');
      }
    }
  },
  watch: {
  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.checkUserInfo;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: v},
        }).then().catch(err => {})
      }
    },
    onShowMob() {
      this.inviteTeamSuccess = null
      this.orderTeam = null
      this.teamOrderSuccess = null
      this.showDialogMob = true
    },
    onCancelMob() {
      this.showDialogMob = false
    },
    onPushMob() {
      if (!this.inviteTeamSuccess && !this.orderTeam && !this.teamOrderSuccess) {
        this.toast("至少推送一条通知", false)
        return
      }
      this.showDialogMob = false
      this.showLoading = true
      const newRequest = gfRequest({
        url: `/api/magic/mob/push`,
        method: 'POST',
        data: {userId: this.memberId, appId: this.appEnv.appId, appKey: this.appEnv.appKey, inviteTeamSuccess: +this.inviteTeamSuccess, orderTeam: +this.orderTeam, teamOrderSuccess: +this.teamOrderSuccess}
      }).then((res) => {
        this.showLoading = false
        this.toast('操作成功，推送消息将在5秒后开始抵达', false)
      }).catch(() => {
        this.showLoading = false
      })
      return newRequest
    },
    handleScroll(event) {
      const {offsetTop, isUp} = event
      requestAnimationFrame(() => {
        if (offsetTop <= 20) {
          const opacity = (100 - (offsetTop * 6)) / 100
          const scale = 'scale( '+ (100 - (offsetTop * 1)) / 100 + ') translateX(-' + (offsetTop * 1.3) + '%)'
          const avatar = 'scale( '+ (100 - (offsetTop * 1.5)) / 100 + ') translateY(-' + offsetTop + '%)'
          this.$refs.userInfo.style.transform = scale
          this.$refs.avatar.style.transform = avatar
          this.$refs.level.style.opacity = opacity
          this.$refs.invite.style.opacity = opacity
        }
        if (offsetTop >= 20 && this.appUserConf.native_header_image && !this.$refs.userInfoWrap.style.backgroundImage) {
          this.$refs.userInfoBg.style.backgroundImage = 'url(' + this.ossUrl + this.appUserConf.native_header_image + ')'
          this.$refs.level.style.opacity = '0'
          this.$refs.invite.style.opacity = '0'
          this.$refs.avatar.style.transform = 'scale(0.7) translateY(-18%)'
          this.$refs.userInfo.style.transform = 'scale(0.8) translateX(-23%)'
        }
        if (offsetTop <= 4 ) {
          this.$refs.userInfoBg.style.backgroundImage = ''
          this.$refs.userInfo.style.transform = ''
          this.$refs.avatar.style.transform = ''
          this.$refs.level.style.opacity = '1'
          this.$refs.invite.style.opacity = '1'
        }
      })
    },
    getMagicConf() {
      const newRequest = gfRequest({
        url: `/api/magic/conf`,
        method: 'GET',
        params: {appid: this.appEnv.appId, appkey: this.appEnv.appKey }
      }).then((res) => {
        const {customCenter, appCoreConf, appUserConf, moduleConf, agentConf, teamConf, ossConf, agentLevel, teamLevel, appKey} = res.data
        this.ossUrl = 'https://' + ossConf['attachment.bucket'] + '.' + ossConf['attachment.endpoint']
        this.openAppKey = appKey
        this.customCenter = customCenter.rows || []
        this.appCoreConf = appCoreConf
        this.appUserConf = appUserConf
        if (!this.appUserConf.withdraw_text_color) {
          this.appUserConf.withdraw_text_color = '#ffffff'
        }
        if (this.appUserConf.header_type) {
          this.headerType = +this.appUserConf.header_type
        }
        this.moduleConf = moduleConf.map(t => {
          t.conf = t.conf || {}
          t.rows = t.rows ? t.rows.map(tt => {
            tt.show = 1
            tt.page = tt.page || ''
            tt.show_level = tt.show_level || ''
            if (tt.type === 'apilink' && (tt.page.includes('https://cloud.playdrumsboy.com/magic/') || tt.page.includes('https://cloud.kilpkonn.com/magic/'))) {
              tt.show = 0
            } else if (tt.show_level !== '') {
              const showLevel = tt.show_level.split('-').map(t => +t)
              if (this.userInfo.agent_level < showLevel[0]) {
                tt.show = 0
              } else if (showLevel.length > 1 && showLevel[1] > 0 && this.userInfo.level_id !== showLevel[1]) {
                tt.show = 0
              }
            }
            return tt
          }).sort((a, b) => {
            return +a.weigh - +b.weigh
          }) : [];
          t._rows = t.rows.filter(t => t.show)
          return t;
        })
        this.moduleBtns = this.moduleConf.find(t => +t.module_id === 5) ? this.moduleConf.find(t => +t.module_id === 5).rows : []
        this.tabBar = this.moduleConf.find(t => +t.module_id === 8 && t.type === 'home') ? moduleConf.find(t => +t.module_id === 8 && t.type === 'home').rows.filter(t => !!+t.chk) : []
        this.agentConf = agentConf
        this.teamConf = teamConf
        this.agentLevel = agentLevel
        this.teamLevel = teamLevel
        this.level_icon = this.ossUrl + this.agentConf.agent_icon_image
        this.isUserUpgrade = +this.appUserConf.native_upgrade_switch
        let agentIndex, teamIndex = -1
        if (this.userInfo.agent_level === 1) {
          if (this.userInfo.level_id > 0) {
            agentIndex = this.agentLevel.findIndex(t => t.id === this.userInfo.level_id);
            if (agentIndex >= 0) {
              this.level_icon = this.ossUrl + this.agentLevel[agentIndex].icon_image
            }
          } else {
            this.level_icon = this.ossUrl + this.agentConf.agent_icon_image
          }
        } else if (this.userInfo.agent_level === 2) {
          if (this.userInfo.level_id > 0) {
            teamIndex = this.teamLevel.find(t => t.id === this.userInfo.level_id);
            if (teamIndex) {
              this.level_icon = this.ossUrl + this.teamLevel[teamIndex].icon_image
            } else {
              this.level_icon = this.ossUrl + this.teamConf.team_icon_image
            }
          } else {
            this.level_icon = this.ossUrl + this.teamConf.team_icon_image
          }
        }
        if (this.isUserUpgrade) {
          if (this.userInfo.agent_level === 0) {
            this.isUserUpgrade = false
          }
          if (this.userInfo.agent_level === 1) {
            if (agentIndex === 0) {
              if (+this.teamConf.team_status === -1) {
                this.isUserUpgrade = false
              }
            }
          }
          if (this.userInfo.agent_level === 2) {
            if (teamIndex === 0 || +this.teamConf.team_status === -1 || !+this.teamLevel[teamIndex]['status']) {
              this.isUserUpgrade = false
            }
          }
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.message);
        }
      });
      return newRequest;
    },
    getMemberMagic() {
      const newRequest = request({
        url: `/open/api/member/magic`,
        method: 'GET',
        params: {
          uid: this.memberId,
        }
      });
      newRequest.then((resp) => {
        if (resp.id > 0) {
          const {num1, num2, num3, num4, num5} = resp
          this.num1 = num1
          this.num2 = num2
          this.num3 = num3
          this.num4 = num4
          this.num5 = num5
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version }
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey } = resp;
        this.appEnv.appKey = version;
        this.checkAppKey = appkey === version;
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    appMemberLink() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          invite_code: this.userInfo.invite_code
        }
      });
      newRequest.then((resp) => {
        this.memberId = resp.id;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    onClickModule(event) {
      if (event.type === 'native_center' || event.type === 'native') {
        if (event.page.includes('h5://')) {
          openAppchannel('H5Page', {
            newH5Url: event.page.replace('h5://', 'https://h5.dhcc.wang/page/').replace('|notop', '')+ '?xid=' + this.openAppKey,
            newH5Title: event.name
          })
        } else {
          openAppchannel(event.page)
        }
      } else if (event.type === 'apilink') {
        openAppchannel('H5Page', {
          newH5Url: event.page,
          newH5Title: event.name
        })
      }
    },
    onChangeNum(k, e) {
      if ((k + 2) <= 5) {
        const key = k + 2
        if (key === 2) {
          this.num2 = e.target.value
        } else if (key === 3) {
          this.num3 = e.target.value
        } else if (key === 4) {
          this.num4 = e.target.value
        } else if (key === 5) {
          this.num5 = e.target.value
        }
      }
      const newRequest = request({
        url: `/open/api/member/magic`,
        method: 'POST',
        data: {
          uid: this.memberId,
          num1: this.num1,
          num2: this.num2,
          num3: this.num3,
          num4: this.num4,
          num5: this.num5,
        }
      });
      newRequest.then(() => {
        this.toast('保存成功', false)
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
    }
  }
}
</script>
